import cabine from '../../../services/cabineApi';
import { gotErrorFromApi } from '../../../utils/api';
import store from '../../configureStore';
import {
  eraserLimitList,
  getLimitListFromApi,
  gotLimitListFromApi,
} from '../../duck/legado/limitApp';
import {
  setFareFilterOptions,
  setFinalDateFilterOptions,
  setInitialDateFilterOptions,
  setPartnerFilterOptions,
  settingFilter,
} from '../../duck/legado/limitApp/filter';
import { SendLoginTokenAuth } from '../tokens';

export function getLimitList(
  partnerId: number | string,
  initialDate: string,
  finalDate: string
) {
  store.dispatch(getLimitListFromApi());
  return (dispatch: any) => {
    cabine
      .get(
        `/v1/legado/consulta/limites/clientes/${partnerId}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        response.data.data_de_pesquisa = {
          de: initialDate,
          ate: finalDate,
        };
        dispatch(gotLimitListFromApi(response.data));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, eraserLimitList);
      });
  };
}

export function setPartnerOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setPartnerFilterOptions(props));
  };
}

export function setFareOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setFareFilterOptions(props));
  };
}

export function setInitialDateOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setInitialDateFilterOptions(props));
  };
}

export function setFinalDateOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setFinalDateFilterOptions(props));
  };
}
